import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchUnit(action: any): any {
    const yieldPuts = [{ type: ACTIONS.UNITS.SEARCH_UNIT, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.UNITS.SEARCH_UNIT, action.payload, true, yieldPuts);
}

export function* addUpdateUnit(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.UNITS.ADD_UPDATE_UNIT, action.payload, true);
}

export function* deleteUnit(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.UNITS.DELETE_UNIT, action.payload, true);
}

export function* unitDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.UNITS.UNIT_DETAILS, action.payload, true);
}
